import { useMemo } from 'react';
import { Box, useTheme } from '@mui/material';
import type { MyChronMapPoint } from '@kangaroo/shared';

import { buildMapPreviewSvgSegments } from '../../lib/mapPreviewLine';

type HomeMiniTrackMapProps = {
  points: MyChronMapPoint[];
  height?: number;
  strokeWidth?: number;
};

export function HomeMiniTrackMap({ points, height = 168, strokeWidth = 2 }: HomeMiniTrackMapProps) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const segments = useMemo(() => buildMapPreviewSvgSegments(points), [points]);

  return (
    <Box
      sx={{
        height,
        width: '100%',
        borderRadius: 1.25,
        overflow: 'hidden',
        bgcolor: 'subtleFill.light',
        border: '1px solid',
        borderColor: 'divider',
        ...(isDark ? {} : { boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.65)' }),
      }}
    >
      <svg width="100%" height={height} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" style={{ display: 'block' }}>
        {segments.map((segment, index) => (
          <line
            key={`${segment.x1}-${segment.y1}-${index}`}
            x1={segment.x1}
            y1={segment.y1}
            x2={segment.x2}
            y2={segment.y2}
            stroke={segment.color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
        ))}
      </svg>
    </Box>
  );
}
